import { render } from "./personalCard.vue?vue&type=template&id=fce3b374"
import script from "./personalCard.vue?vue&type=script&lang=js"
export * from "./personalCard.vue?vue&type=script&lang=js"

import "./personalCard.vue?vue&type=style&index=0&id=fce3b374&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__